import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {IConstantItem} from 'src/app/core/models/available-types.interface';
import {IPalette} from 'src/app/modules/customers-order-management/models/palette.interface';
import {
    IPackage_ProductAllocation, PackingTypeNew,
    UnitsOfMeasure
} from '../../../../../../shared/components/product-allocation-new/product-allocation-new.component';

@Component({
    selector: 'eci-package-details-table',
    templateUrl: './package-details-table.component.html',
    styleUrls: ['./package-details-table.component.scss']
})
export class PackageDetailsTableComponent implements OnInit, OnChanges {
    constructor() {}

    @Input() summaryPage = false;
    @Input() data: IPackage_ProductAllocation[] | any;
    @Input() weightUnits: IConstantItem[];
    @Input() isCreateMode: boolean;
    @Input() denominator: number = 1;

    @Output() dataChange: EventEmitter<IPalette[]> = new EventEmitter<IPalette[]>();

    dataSource = new MatTableDataSource<IPackage_ProductAllocation>([]);

    displayedColumns: string[] = [
        'packingTypeText',
        'packingQuantity',
        'length',
        'width',
        'height',
        'units',
        'unitsOfMeasure',
        'grossWeight',
        'volume'
    ];

    ngOnInit(): void {
        this.dataSource.data = this.data || [];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data) {
            this.dataSource.data = changes.data.currentValue || [];
        }
    }

    getPackingType(element) {
        switch (element.packingType){
            case PackingTypeNew.single_carton:
                return 'Single carton';
            case PackingTypeNew.pallet:
                return 'Pallet';
            default: return '';
        }
    }

    getNumberOfCarton(element) {
        if (element.packingType === PackingTypeNew.single_carton) return 1;
        else return element?.cartons?.length;
    }

    getUnit(unitsOfMeasure: number) {
        return UnitsOfMeasure[unitsOfMeasure];
    }
}
